import { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton, Typography } from 'shared/ui'
import { formatBytesToNumberWithType } from 'shared/lib'

import styles from './styles.module.scss'

type IUploadedFileCardProps = {
  file: File
  type: 'image' | 'video'
  onRemove: () => void
}

export const UploadedFileCard = observer(({ file, type, onRemove }: IUploadedFileCardProps) => {
  const url = useMemo(() => URL.createObjectURL(file), [file])

  useEffect(() => () => URL.revokeObjectURL(url), [url])

  return (
    <div className={styles.card}>
      <div className={styles.info}>
        <div className={styles.preview}>
          {type === 'image' ? (
            <img className={styles.media} src={url} alt='' />
          ) : (
            // eslint-disable-next-line jsx-a11y/media-has-caption
            <video className={styles.media} src={url} />
          )}
        </div>
        <div className={styles.meta}>
          <Typography
            ariaLabel='UploadedFileCard_name'
            variant='body-md-regular'
            color='var(--content-primary-primary)'
            ellipsis
          >
            {file.name}
          </Typography>
          <Typography
            ariaLabel='UploadedFileCard_size'
            variant='body-sm-regular'
            color='var(--content-primary-tertiary)'
          >
            {formatBytesToNumberWithType(file.size)}
          </Typography>
        </div>
      </div>
      <IconButton
        icon='close'
        ariaLabel='delete_file'
        size='small'
        variant='icon'
        color='tertiary'
        onClick={onRemove}
      />
    </div>
  )
})
